import React from 'react';

import Button from '@material-ui/core/Button';
import SaveIcon from '@material-ui/icons/Save';
import { withStyles } from '@material-ui/core/styles';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import WishForm from 'components/WishForm';

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit
  }
});

class EditWish extends React.Component {
  handleSave = () => {
    const { wish, edits, wishId, onSave } = this.props;
    const editedWish = Object.assign({}, wish, edits);
    onSave && onSave(editedWish, wishId);
  }

  render() {
    const { open, onChange, onCancel, wish, edits, wishId, fullScreen } = this.props

    const editedWish = Object.assign({}, wish, edits);

    return (
      <Dialog
        open={ open }
        onClose={ this.handleClose }
        aria-labelledby="form-dialog-title"
        key="form"
        fullScreen={ fullScreen }
      >
        <DialogTitle id="form-dialog-title">Edit Wish</DialogTitle>
        <DialogContent>
          <WishForm
            onChange={ (field, value) => onChange(field, value, wishId) }
            onConfirm={ this.handleSave }
            wish={ editedWish }
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" onClick={ this.handleSave }>
            <SaveIcon />
            Save
          </Button>
          <Button onClick={ () => onCancel(wishId) }>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(EditWish);



// WEBPACK FOOTER //
// ./src/components/dialogs/EditWish/EditWish.js